import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/shared/contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';
import { isEmailVerified } from '@/shared/utils/emailVerified';

/**
 * Auth-restricted route wrapper
 * Only accessible to unauthenticated users
 * Redirects authenticated users to dashboard
 */
function AuthRestrictedRoutes({ children }) {
    const { currentUser, loading, linking } = useAuth();
    const location = useLocation();

    if (loading) {
        return <LoadingSpinner />;
    }

    // A link in flight has already signed the person in with their password
    // and is waiting on the link itself; leaving now would unmount the page
    // that has to show the outcome if the link is refused.
    if (isEmailVerified(currentUser) && !linking) {
        // Redirect verified users to their intended destination or dashboard
        const from = location.state?.from?.pathname || '/dashboard';
        return <Navigate to={from} replace />;
    }

    return children;
}

export default AuthRestrictedRoutes;
